import { __rest } from "tslib";
import React, { PureComponent, Fragment } from "react";
import { ScrollView } from "@al/akui-mobile";
/**
 * 仿 RN FlatList
 * @version 1.0.0
 * @class
 */

export class FlatList extends PureComponent {
  render() {
    const _a = this.props,
          {
      data,
      renderItem,
      ItemSeparatorComponent,
      ListEmptyComponent,
      ListFooterComponent,
      ListHeaderComponent,
      keyExtractor
    } = _a,
          otherProps = __rest(_a, ["data", "renderItem", "ItemSeparatorComponent", "ListEmptyComponent", "ListFooterComponent", "ListHeaderComponent", "keyExtractor"]);

    return React.createElement(ScrollView, Object.assign({}, otherProps), ListHeaderComponent, data && data.length > 0 ? data.map((item, index) => {
      const key = keyExtractor ? keyExtractor(item, index) : index;
      return React.createElement(Fragment, {
        key: key
      }, index !== 0 ? ItemSeparatorComponent : null, renderItem({
        item,
        index
      }));
    }) : ListEmptyComponent, ListFooterComponent);
  }

}